import React, { useState, useEffect } from "react";
import { getEmailTemplates, searchCustomerWithEmail, getJobTypes } from "../../service/ApiServices";
import Select from "react-select";
import Swal from "sweetalert2";
import axios from "axios";

const Email = () => {
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [placeholderValues, setPlaceholderValues] = useState({});
  const [previewEmails, setPreviewEmails] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [jobTypes, setJobTypes] = useState([]);
  const [selectedJobTypes, setSelectedJobTypes] = useState({});
  const [customerLoading, setCustomerLoading] = useState(false);
  const [placeholderInstances, setPlaceholderInstances] = useState([]);
  const [loading2, setLoading2] = useState(false);
  const [subjectPlaceholderInstances, setSubjectPlaceholderInstances] = useState([]);
  const [bodyPlaceholderInstances, setBodyPlaceholderInstances] = useState([]);

  useEffect(() => {
    fetchTemplates();
    fetchJobTypes();
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    try {
      setCustomerLoading(true);
      const response = await searchCustomerWithEmail();
      
      if (response.data) {
        console.log(response.data)
        const customerOptions = response.data.map((customer) => ({
          value: customer._id,
          label: customer.customerName,
          ...customer
        }));
        
        setCustomers(customerOptions);
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to fetch customers'
      });
    } finally {
      setCustomerLoading(false);
    }
  };

  const fetchJobTypes = async () => {
    try {
      setLoading(true);
      const response = await getJobTypes();
      
      if (response) {
        const jobTypeOptions = response.map((jobType) => ({
          value: jobType.value,
          label: jobType.label,
        }));
        setJobTypes(jobTypeOptions);
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to fetch job types'
      });
    } finally {
      setLoading(false);
    }
  };
 
  const fetchTemplates = async () => {
    try {
      setLoading(true);
      const response = await getEmailTemplates();
      if (response.data && response.data.EmailTemplates) {
        const templateOptions = response.data.EmailTemplates.map((template) => ({
          value: template._id,
          label: template.templateName,
          subject: template.templateSubject,
          description: template.templateDescription,
          placeholders: template.placeholders
        }));
        
        setTemplates(templateOptions);
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to fetch templates'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleTemplateChange = (selected) => {
    setSelectedTemplate(selected);
    setPlaceholderValues({});
    setSelectedCustomers([]);
    setSelectedJobTypes({});
    setPreviewEmails([]);
    
    if (selected?.description || selected?.subject) {
      const subjectInstances = findPlaceholderInstances(selected.subject || '');
      const bodyInstances = findPlaceholderInstances(selected.description || '');
      setSubjectPlaceholderInstances(subjectInstances);
      setBodyPlaceholderInstances(bodyInstances);
      setPlaceholderInstances([...subjectInstances, ...bodyInstances]);
    } else {
      setSubjectPlaceholderInstances([]);
      setBodyPlaceholderInstances([]);
      setPlaceholderInstances([]);
    }
  };

  const findPlaceholderInstances = (template) => {
    const regex = /{{([^}]+)}}/g;
    const instances = [];
    let match;
    
    while ((match = regex.exec(template)) !== null) {
      instances.push({
        placeholder: match[1].trim(),
        position: match.index,
        id: `${match[1].trim()}-${match.index}`,
        fullMatch: match[0]
      });
    }
    
    return instances;
  };

  const handleCustomersSelect = (selected) => {
    setSelectedCustomers(selected || []);
    updateAllPreviews(selected || []);
  };

  const handleJobTypeSelect = (selected, instanceId) => {
    
    const updatedJobTypes = {
      ...selectedJobTypes,
      [instanceId]: selected
    };
    
    
    setSelectedJobTypes(updatedJobTypes);
    updateAllPreviews(selectedCustomers, null, updatedJobTypes);
  };

  const handlePlaceholderChange = (instanceId, value) => {
    const newValues = {
      ...placeholderValues,
      [instanceId]: value
    };
    
    setPlaceholderValues(newValues);
    updateAllPreviews(selectedCustomers, newValues);
  };

  const generatePreviewForCustomer = (customer, currentPlaceholderValues = null, currentJobTypes = null) => {
    const placeholders = currentPlaceholderValues || placeholderValues;
    const jobTypes = currentJobTypes || selectedJobTypes;
    let previewSubject = selectedTemplate.subject || '';
    let previewBody = selectedTemplate.description || '';

    // Replace subject placeholders
    const sortedSubjectInstances = [...subjectPlaceholderInstances].sort((a, b) => b.position - a.position);
    sortedSubjectInstances.forEach(instance => {
      let value;
      if (instance.placeholder === 'CUSTOMER NAME' || instance.placeholder.toUpperCase() === 'CUSTOMER_NAME') {
        value = customer.customerName;
      } else if (instance.placeholder === 'ITEM TYPE' || instance.placeholder.toUpperCase() === 'ITEM_TYPE') {
        const jobType = jobTypes[instance.id];
        value = jobType ? jobType.label : null;
      } else {
        value = placeholders[instance.id];
      }
      const replacement = value ? ` ${value}` : instance.fullMatch;
      previewSubject =
        previewSubject.substring(0, instance.position) +
        replacement +
        previewSubject.substring(instance.position + instance.fullMatch.length);
    });

    // Replace body placeholders
    const sortedBodyInstances = [...bodyPlaceholderInstances].sort((a, b) => b.position - a.position);
    sortedBodyInstances.forEach(instance => {
      let value;
      if (instance.placeholder === 'CUSTOMER NAME' || instance.placeholder.toUpperCase() === 'CUSTOMER_NAME') {
        value = customer.customerName;
      } else if (instance.placeholder === 'ITEM TYPE' || instance.placeholder.toUpperCase() === 'ITEM_TYPE') {
        const jobType = jobTypes[instance.id];
        value = jobType ? jobType.label : null;
      } else {
        value = placeholders[instance.id];
      }
      const replacement = value ? ` ${value}` : instance.fullMatch;
      previewBody =
        previewBody.substring(0, instance.position) +
        replacement +
        previewBody.substring(instance.position + instance.fullMatch.length);
    });
    return { subject: previewSubject, body: previewBody };
  };

  const updateAllPreviews = (customers, updatedPlaceholderValues = null, updatedJobTypes = null) => {
    if (!selectedTemplate?.description || !customers.length) {
      setPreviewEmails([]);
      return;
    }
    const currentPlaceholderValues = updatedPlaceholderValues || placeholderValues;
    const currentJobTypes = updatedJobTypes || selectedJobTypes;
    const previews = customers.map(customer => {
      const { subject, body } = generatePreviewForCustomer(customer, currentPlaceholderValues, currentJobTypes);
      return {
        customer: customer,
        subject,
        body
      };
    });
    setPreviewEmails(previews);
  };

  const renderCustomerSelect = () => {
    return (
      <div className="mb-3">
        <label className="form-label">Select Customers</label>
        <Select
          options={customers}
          value={selectedCustomers}
          onChange={handleCustomersSelect}
          isLoading={customerLoading}
          placeholder="Select customers..."
          isClearable
          isMulti
          noOptionsMessage={() => "No customers available"}
          className="basic-multi-select"
          classNamePrefix="select"
        />
      </div>
    );
  };

  const renderPlaceholderInput = (instance) => {
    const { placeholder, id } = instance;
    const normalizedPlaceholder = placeholder.replace(/\s+/g, '_').toUpperCase();

    if (normalizedPlaceholder === 'CUSTOMER_NAME' || placeholder === 'CUSTOMER NAME') {
      return null;
    }
    
    if (normalizedPlaceholder === 'ITEM_TYPE' || placeholder === 'ITEM TYPE') {
      return (
        <div key={id} className="mb-3">
          <label className="form-label">Select Item Type </label>
          <Select
            options={jobTypes}
            value={selectedJobTypes[id] || null}
            onChange={(selected) => handleJobTypeSelect(selected, id)}
            placeholder="Select item type..."
            isClearable
            isLoading={loading}
            noOptionsMessage={() => "No job types available"}
            className="basic-single"
            classNamePrefix="select"
          />
        </div>
      );
    }

    if (normalizedPlaceholder === 'DATE' || placeholder === 'Select Date') {
      return (
        <div key={id} className="mb-3">
          <label className="form-label">Select Date</label>
          <input
            type="date"
            className="form-control"
            value={placeholderValues[id] || ''}
            onChange={(e) => handlePlaceholderChange(id, e.target.value)}
          />
        </div>
      );
    }

    return (
      <div key={id} className="mb-3">
        <label className="form-label">{placeholder}</label>
        <input
          type="text"
          className="form-control"
          value={placeholderValues[id] || ''}
          onChange={(e) => handlePlaceholderChange(id, e.target.value)}
          placeholder={`Enter ${placeholder.toLowerCase()}`}
        />
      </div>
    );
  };

  const SendEmailToClient = async () => {
    setLoading2(true);
    try {
      for (const preview of previewEmails) {
        await axios.post('/email/send-template-email', {
          to: preview.customer.customerEmail,
          subject: preview.subject,
          body: preview.body
        });
      }
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Emails sent successfully!',
        timer: 2000,
        showConfirmButton: false
      });
      setSelectedTemplate(null);
      setPreviewEmails([]);
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || error.message || 'Failed to send emails',
      });
      console.error('Email sending error:', error);
    } finally {
      setLoading2(false);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Send Email</h4>
              <h6>Send Personalized Emails to your clients</h6>
            </div>
          </div>
        </div>

        <div className="row">
          {/* Left Side - Email Details */}
          <div className="col-md-6">
            <div className="card">
              <div className="card-body">
                <div className="mb-4">
                  <label className="form-label">Select Template</label>
                  <Select
                    options={templates}
                    value={selectedTemplate}
                    onChange={handleTemplateChange}
                    placeholder="Choose a template..."
                    isLoading={loading}
                    className="mb-3"
                  />
                </div>

                {selectedTemplate && (
                  <div className="placeholder-inputs">
                    <h6 className="mb-3">Fill Placeholder Values</h6>
                    {renderCustomerSelect()}
                    {placeholderInstances.map((instance) => (
                      <React.Fragment key={instance.id}>
                        {renderPlaceholderInput(instance)}
                      </React.Fragment>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Right Side - Email Preview */}
          <div className="col-md-6">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title mb-4">Email Previews</h5>
                {previewEmails.length > 0 ? (
                  <div>
                    {previewEmails.map((preview, index) => (
                      <div key={index} className="email-preview p-3 border rounded mb-3">
                        <h6 className="mb-2">For: {preview.customer.customerName}</h6>
                        <div className="mb-2">
                          <strong>Subject:</strong>
                          <pre className="mb-0" style={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit' }}>
                            {preview.subject}
                          </pre>
                        </div>
                        <div>
                          <strong>Body:</strong>
                          <div 
                            className="email-body-preview"
                            style={{ 
                              border: '1px solid #ddd',
                              padding: '15px',
                              borderRadius: '4px',
                              backgroundColor: '#fff'
                            }}
                            dangerouslySetInnerHTML={{ __html: preview.body }}
                          />
                        </div>
                      </div>
                    ))}
                    <div className="mt-4">
                      <button 
                        className="btn btn-primary"
                        disabled={previewEmails.length === 0 || loading2}
                        onClick={SendEmailToClient}
                      >
                        {loading2 ? 'Sending...' : `Send ${previewEmails.length} Email${previewEmails.length > 1 ? 's' : ''}`}
                      </button>
                    </div>
                  </div>
                ) : (
                  <p className="text-muted mb-0">
                    Select a template, fill in the placeholders, and select one or more customers to see the previews
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Email;